import React from 'react'

export const MessageSitter = () => {
    return (
        <>
            {/* <!-- Message Vendor --> */}
            <div id="booking-widget-anchor" className="boxed-widget booking-widget message-vendor margin-top-35">
                <h3><i className="fa fa-envelope-o"></i> Message Vendor</h3>
                <div className="row with-forms  margin-top-0">

                    <div className="col-lg-12">
                        <input type="text" placeholder="First and Last Name" value="Tom Smith" />
                        <input type="text" placeholder="Email" value="mail@example.com" />
                        <input type="text" placeholder="Phone" value="+12 345 678 910" />
                        <textarea name="" id="" cols="10" rows="2" placeholder="Message"></textarea>
                    </div>

                    {/* <!-- Preferred Contact Methos Radios --> */}
                    <div className="col-lg-12">
                        <div className="preferred-contact-method">
                            <h5>Preferred contact method</h5>

                            <div className="preferred-contact-radios">
                                <div className="radio">
                                    <input id="radio-1" name="radio" type="radio" checked />
                                    <label for="radio-1"><span className="radio-label"></span> Email</label>
                                </div>

                                <div className="radio">
                                    <input id="radio-2" name="radio" type="radio" />
                                    <label for="radio-2"><span className="radio-label"></span> Phone</label>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {/* <!-- Recaptcha Holder --> */}
                <div className="captcha-holder">
                    {/* <!-- Recaptcha goes here --> */}
                </div>

                {/* <!-- Book Now --> */}
                <a href="#" className="button book-now fullwidth margin-top-5">Request Pricing</a>
            </div>
        </>
    )
}





